import { render } from "./AdvertisementBanner.vue?vue&type=template&id=5c631b15&scoped=true"
import script from "../js/advertisement-banner.js?vue&type=script&lang=js"
export * from "../js/advertisement-banner.js?vue&type=script&lang=js"

import "./AdvertisementBanner.vue?vue&type=style&index=0&id=5c631b15&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c631b15"]])

export default __exports__